import { useRef } from 'react';
import { renderStore } from './render-tracker';

let instanceCounter = 0;

const enabled = renderStore.isEnabled();

export function useRenderTracker(componentName: string, props?: Record<string, unknown>): void {
  const instanceIdRef = useRef<string>('');
  const renderCountRef = useRef(0);
  const prevPropsRef = useRef<Record<string, unknown> | undefined>(undefined);

  if (!enabled) return;

  if (!instanceIdRef.current) {
    instanceIdRef.current = `${componentName}_${++instanceCounter}`;
  }

  const isMount = renderCountRef.current === 0;
  renderCountRef.current++;

  let changedProps: string[] | undefined;
  if (props && prevPropsRef.current) {
    changedProps = [];
    const allKeys = new Set([...Object.keys(props), ...Object.keys(prevPropsRef.current)]);
    for (const key of allKeys) {
      if (props[key] !== prevPropsRef.current[key]) {
        changedProps.push(key);
      }
    }
  }
  prevPropsRef.current = props;

  renderStore.recordRender({
    componentName,
    instanceId: instanceIdRef.current,
    renderPhase: isMount ? 'mount' : 'update',
    appPhase: renderStore.currentAppPhase,
    changedProps,
  });
}
